import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { BarChart3, Database, LogOut, UserCircle } from "lucide-react";
import { useAuth } from "@/components/providers/auth-provider";

export function Header() {
  const { user, isAdmin, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Cerrar el dropdown al hacer click fuera o pulsar Escape.
  useEffect(() => {
    if (!menuOpen) return;
    const handleClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, [menuOpen]);

  return (
    <header className="bg-surface border-b border-line px-4 lg:px-6 h-14 flex items-center justify-between">
      <Link to="/proyectos" className="flex items-center gap-2 group">
        <span className="grid place-items-center w-8 h-8 bg-brand text-white">
          <Database className="w-4 h-4" />
        </span>
        <span className="font-heading text-ink tracking-tightest group-hover:text-brand-hover transition-colors">
          RAG Interno<span className="cuerva-asterisk ml-0.5">*</span>
        </span>
      </Link>

      <div className="relative" ref={menuRef}>
        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="p-1 text-content-muted hover:text-ink transition-colors"
          aria-label="Perfil de usuario"
          aria-haspopup="menu"
          aria-expanded={menuOpen}
        >
          <UserCircle className="w-8 h-8" />
        </button>
        {menuOpen && (
          <div
            role="menu"
            className="absolute right-0 mt-2 w-64 bg-surface border border-line rounded-md shadow-card z-50 overflow-hidden"
          >
            {user && (
              <div className="px-4 py-3 border-b border-line">
                <div className="text-sm font-heading font-semibold text-ink truncate">
                  {user.name || user.email}
                </div>
                {user.name && (
                  <div className="text-xs text-content-muted truncate">
                    {user.email}
                  </div>
                )}
                {isAdmin && (
                  <span className="inline-block mt-1 px-2 py-0.5 text-[10px] font-heading font-semibold uppercase tracking-wider bg-brand/10 text-brand-hover rounded-pill">
                    Administrador
                  </span>
                )}
              </div>
            )}
            {isAdmin && (
              <Link
                to="/uso"
                role="menuitem"
                onClick={() => setMenuOpen(false)}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm text-content hover:bg-surface-100 transition-colors"
              >
                <BarChart3 className="w-4 h-4" />
                Consumo de IA
              </Link>
            )}
            <button
              onClick={() => {
                setMenuOpen(false);
                logout();
              }}
              role="menuitem"
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-danger hover:bg-danger/10 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Cerrar sesión
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
